/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

export class ThuzzRatingTypes {
    public static readonly DULL_GAME: string = 'Dull Game';

    public static readonly OK_GAME: string = 'Ok Game';

    public static readonly GOOD_GAME: string = 'Good Game';

    public static readonly GREAT_GAME: string = 'Great Game';
}
